import { CampaignType } from '../model/CampaignsModel';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import TriggerActions from './TriggerCRUDActions';
import PromotersActions from './PromoterCRUDActions';
import { BePromoterModel, mapBEtoFE } from '../controllers/PromoterController';

export const dispatchCampaignPostUpdates = (
  dispatch: Dispatch<StoreState>,
  campaign: CampaignType,
) => {
  if (!campaign.campaignAudiencesAttributes) {
    return;
  }

  for (let i = 0; i < campaign.campaignAudiencesAttributes.length; i += 1) {
    const attr = campaign.campaignAudiencesAttributes[i];

    if (attr.trigger) {
      switch (attr.trigger.kind) {
        case 'instagram_keywords':
        case 'facebook_keywords':
        case 'webchat_keywords':
        case 'sms_keywords': {
          dispatch({
            type: TriggerActions.updateAction,
            entity: attr.trigger,
          });
          break;
        }
      }
    }

    if (attr.promoter) {
      switch (attr.kind) {
        default: {
          dispatch({
            type: PromotersActions.updateAction,
            entity: mapBEtoFE(attr.promoter as BePromoterModel),
          });
        }
      }
    }
  }
};
